<div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
  <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">Search</h2>
  <form [formGroup]="filterForm" (ngSubmit)="Search()" class="w-full flex flex-wrap">
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
      <b class="text-left font-normal text-base" style="color: #424242;">From Date</b>
      <p-calendar formControlName="fromDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
        class="w-full" styleClass="cal_full" />
    </div>
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
      <b class="text-left font-normal text-base" style="color: #424242;">To Date</b>
      <p-calendar formControlName="toDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
        class="w-full" styleClass="cal_full" />
    </div>
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
      <b class="text-left font-normal text-base" style="color: #424242;">Status</b>
      <p-dropdown formControlName="status" [options]="statuses" optionLabel="name" optionValue="value" placeholder="Select Status"
        class="w-full" styleClass="selectFull" />
    </div>
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column justify-content-end">
      <p-button label="Search" [loading]="isSearching" [disabled]="filterForm.invalid" class="w-full"
        styleClass="buttonFull" type="submit" (onClick)="Search()" />
    </div>
  </form>
</div>

